module.exports = __webpack_public_path__ + "img/avatar_dark.a2f09a6e.png";